export enum TokenInjectionType {
    ignore = 0,
    query = 1,
    fragment = 2
  }
  